/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import './SharedOwnerNotification.styles.scss';

import { selectors as listSelectors } from '../../../../redux/ducks/lists/lists';
import { actions as notificationActions } from '../../../../redux/ducks/notifications';
import ProfileActions from '../../../redux/ProfileActions';

import ProfileAvatar from '../../../../components/ProfileAvatar';
import FlexRow from '../../../../components/FlexRow';
import Card, { CardSection } from '../../../../components/card/Card';
import { navigate } from '../../../redux/NavigationActions';
import RouteNames from '../../../RouteNames';
import SharedOwnerNotificationModel  from '../../../../../models/SharedOwnerNotificationModel';

function mapStateToProps(state) {
  return {
    colorThemes: listSelectors.getColorThemes(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    acceptInvite: (notificationId) => {
      return dispatch(notificationActions.acceptOwnerInvite(notificationId));
    },
    rejectInvite: (notificationId) => {
      dispatch(notificationActions.rejectOwnerInvite(notificationId));
    },
    switchToProfile: (profileData) => {
      return dispatch(ProfileActions.switchToProfile(profileData));
    },
  };
}

interface Props {
  notification: any;

  acceptInvite(id): void;
  rejectInvite(id): void;
  colorThemes: any[];
  switchToProfile(data): void;
}

class SharedOwnerNotification extends React.Component<Props> {

  acceptInvite = async () => {
    const { notification } = this.props;

    const soNotification = new SharedOwnerNotificationModel(notification);
    const sharedProfile = soNotification.sharedProfile;

    await this.props.acceptInvite(notification.id);
    await ProfileActions.requestAllProfiles();
    await this.props.switchToProfile(sharedProfile.data);

    navigate(RouteNames.profileInfo());
  }

  rejectInvite = () => {
    const { notification } = this.props;

    this.props.rejectInvite(notification.id);
  }

  render() {
    const { notification } = this.props;
    const soNotification = new SharedOwnerNotificationModel(notification);

    const profile = soNotification.sharedProfile;
    const requestorProfileName = soNotification.requestorProfile.greetingName();
    const profileName = profile.greetingName();
    const msgId = soNotification.isSharedProfileRequestorProfile ? 'notification.ownershipInvite.requestorProfile.message' : 'notification.OwnershipInvite.message';

    return (
      <Card>
        <CardSection hasBorder>
          <FlexRow className="">
            <FormattedMessage id={msgId} values={{ string1: requestorProfileName, string2: profileName }} />

            <div style={{ marginLeft: 24 }}>
              <ProfileAvatar profile={profile} size={48} fontSize={15} />
            </div>
          </FlexRow>
        </CardSection>

        <div className="cmp-notification-controls bkgd-color-csAppBGgray">
            <button className="font-body font-color-profile-accent border-color-gsLight" onClick={this.acceptInvite}>
              <FormattedMessage id="notification.accept.button.label" />
            </button>

            <button className="font-body font-color-profile-accent" onClick={this.rejectInvite}>
              <FormattedMessage id="notification.reject.button.label" />
            </button>
        </div>
      </Card>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SharedOwnerNotification);
